import AOS from 'aos';

export default function initAOS() {
  if (!Shopify.designMode) {
    AOS.init({ disable: true, duration: 1200, offset: 0 });
  }
}
